interface AvatarProps {
  name: string;
  url?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isAgent?: boolean;
  status?: 'online' | 'offline' | 'busy';
}

const SIZES = {
  sm: 'w-6 h-6 text-2xs',
  md: 'w-9 h-9 text-xs',
  lg: 'w-14 h-14 text-lg',
  xl: 'w-20 h-20 text-2xl',
};

function getInitials(name: string): string {
  return name
    .split(/[\s-_]+/)
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase();
}

function getColor(name: string): string {
  const colors = [
    'bg-sym-600', 'bg-emerald-600', 'bg-blue-600', 'bg-amber-600',
    'bg-rose-600', 'bg-cyan-600', 'bg-pink-600', 'bg-indigo-600',
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
}

export function Avatar({ name, url, size = 'md', isAgent, status }: AvatarProps) {
  const sizeClass = SIZES[size];

  return (
    <div className="relative inline-flex shrink-0">
      {url ? (
        <img
          src={url}
          alt={name}
          className={`${sizeClass} rounded-full object-cover`}
          style={{
            border: isAgent ? '2px solid var(--accent-purple)' : '1px solid var(--border-card)',
          }}
        />
      ) : (
        <div
          className={`${sizeClass} ${getColor(name)} rounded-full flex items-center justify-center font-semibold text-white`}
          style={{
            border: isAgent ? '2px solid var(--accent-purple)' : '1px solid var(--border-card)',
          }}
        >
          {getInitials(name)}
        </div>
      )}
      {status && (
        <span
          className={`absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full ${
            status === 'online' ? 'bg-emerald-400' :
            status === 'busy' ? 'bg-amber-400' : 'bg-zinc-400'
          }`}
          style={{ border: '2px solid var(--bg-card)' }}
        />
      )}
      {isAgent && !status && (
        <span
          className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-sym-400"
          style={{ border: '2px solid var(--bg-card)' }}
        />
      )}
    </div>
  );
}
